import React, { useState, useMemo } from "react";
import { useParams } from "react-router-dom";
import { ApiEndpoint } from "../../utils/ApiEndpoint";
import CustomerPartners from "./_CustomerPartners";
import UsersByCustomer from "./_UsersByCustomer";
import CustomerPrices from "./_CustomerPrices";
import ShortCodesListByCustomer from "./_ShortCodesListByCustomer";
import { httpClient } from "../../utils/HttpClient";
import { useAuth } from "../../Context/AuthContext";
import { useQuery } from "@tanstack/react-query";
import Loading from "../../components/ui/Suspense";
import CustomerAgentRCS from "../../components/dashboard/administration/customer/CustomerAgentRCS";
import ListPricesRCS from "../../components/dashboard/administration/customer/ListPricesRCS";
const CustomerDetail = () => {
  const Auth = useAuth();
  const { id } = useParams();
  const userData = Auth.getSessionData();
  const channels = Auth.getUserChannel();

  const [partnersData, setPartnersData] = useState([]);

  const [activeTab, setActiveTab] = useState("General");

  const TABS = [
    {
      label: "General",
      icon: "Settings",
    },
    {
      label: "SMS",
      icon: "sms",
    },
    {
      label: "RCS",
      icon: "smartphone",
    },
  ];

  const tabs = useMemo(() => {
    if (channels.includes("ALL")) {
      return TABS;
    }

    return TABS.filter((item) => channels.includes(item.toLowerCase()));
  }, [channels]);

  const { data: customerInfo, isFetching } = useQuery({
    queryKey: ["customerInfo", id],
    queryFn: async () => {
      const response = await httpClient(
        "GET",
        `${ApiEndpoint}administration/customer/${id}`,
        {},
        userData.token,
      );
      return response.data;
    },
    refetchOnWindowFocus: false,
    initialData: null,
  });

  if (isFetching) {
    return <Loading />;
  }

  const renderTabContent = () => {
    switch (activeTab) {
      case "General":
        return (
          <>
            <div className="wrapp">
              <CustomerPartners
                idCustomer={customerInfo.idcustomer}
                setPartnersData={setPartnersData}
                partnersData={partnersData}
              />
            </div>
            <div className="wrapp">
              <UsersByCustomer idCustomer={customerInfo.idcustomer} />
            </div>
          </>
        );
      case "SMS":
        return (
          <>
            <div className="wrapp">
              <ShortCodesListByCustomer
                uidCustomer={id}
                idCustomer={customerInfo.idcustomer}
                partnersData={partnersData}
              />
            </div>
            <div className="wrapp">
              <CustomerPrices
                idCustomer={customerInfo.idcustomer}
                uidCustomer={id}
              />
            </div>
          </>
        );
      case "RCS":
        return (
          <>
            <div className="wrapp">
              <ListPricesRCS
                uidCustomer={customerInfo.uidCustomer}
                idCustomer={customerInfo.idcustomer}
                partnersData={partnersData}
              />
            </div>
            <div className="wrapp">
              <CustomerAgentRCS
                uidCustomer={customerInfo.uidCustomer}
                idCustomer={customerInfo.idcustomer}
                partnersData={partnersData}
              />
            </div>
          </>
        );
    }
  };
  return (
    <>
      {customerInfo && (
        <>
          <h2>Detalle de Cliente {customerInfo.comercialname}</h2>
          <h4>Información</h4>

          <div className="w-full grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 mb-6 gap-2 p-1 bg-white rounded-lg">
            {tabs.map((item, index) => (
              <button
                key={index}
                onClick={() => setActiveTab(item.label)}
                className={`px-4 py-2 rounded-lg border-none transition duration-300 ease-in-out flex items-center gap-2 ${
                  activeTab === item.label ? "bg-gray-200" : " bg-white"
                }`}
              >
                <span className="material-symbols-outlined">{item.icon}</span>

                <span className="text-sm font-semibold">{item.label}</span>
              </button>
            ))}
          </div>
          {renderTabContent()}
        </>
      )}
    </>
  );
};

export default CustomerDetail;
